import { useId } from 'react';

import Typography from 'components/shared/Typography/Typography';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import { SCOPE_OPTIONS } from 'components/Patient/checkin/SecurePayment/components/Letter/lib/helpers';

const SCOPE_CHOICES = [
  {
    value: SCOPE_OPTIONS.VISIT,
    title: 'This visit:',
    description: 'Authorize for today’s visit'
  },
  {
    value: SCOPE_OPTIONS.YEAR,
    title: 'All visits this year:',
    description: 'Covers all visits this year'
  }
];

const ChoiceLabel = ({ id, title, description }) => (
  <label htmlFor={id} className="cursor-pointer">
    <div className="flex items-center gap-0.5">
      <Typography variant="span" size="small" weight="medium" color="neutral-800">
        {title}
      </Typography>
      <Typography variant="span" size="small" color="neutral-600">
        {description}
      </Typography>
    </div>
  </label>
);

const PatientChoose = ({ value, onChange }) => {
  const visitId = useId();
  const yearId = useId();
  const ids = { [SCOPE_OPTIONS.VISIT]: visitId, [SCOPE_OPTIONS.YEAR]: yearId };

  return (
    <div className="flex flex-col gap-1.5">
      <Typography variant="label" size="medium" weight="medium" color="neutral-800">
        Choose
      </Typography>
      <div className="flex flex-wrap gap-2">
        {SCOPE_CHOICES.map((choice) => {
          const id = ids[choice.value];
          return (
            <RadioButton
              key={choice.value}
              id={id}
              name="preauth-scope"
              value={choice.value}
              label={<ChoiceLabel id={id} title={choice.title} description={choice.description} />}
              isSelected={value === choice.value}
              onChange={() => onChange(choice.value)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PatientChoose;
